export default __webpack_public_path__ + "static/media/bain.33d7223b.png";